import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  required,
} from "react-admin";
import type { EditProps } from "react-admin";

const STATUS = [
  { id: "DRAFT", name: "Draft" },
  { id: "ACTIVE", name: "Active" },
  { id: "COMPLETED", name: "Completed" },
  { id: "ARCHIVED", name: "Archived" },
];

export const ProjectEdit = (props: EditProps) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="code" fullWidth />
      <TextInput source="description" multiline fullWidth />
      <SelectInput source="status" choices={STATUS} />
      <NumberInput source="estimatedBudget" min={0} />
      <NumberInput source="unitAmount" min={0} />
      <TextInput source="currency" />
      <DateInput source="estimatedCompletionDate" />
    </SimpleForm>
  </Edit>
);
